module.exports = __webpack_public_path__ + "img/new-truck-gray.0bec3f0c.svg";